var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11411_57199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.9414,
    r: 45,
    fill: "url(#paint0_radial_11411_57199)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.9414,
    r: 45,
    fill: "url(#paint1_linear_11411_57199)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4531 66.5312H62.5469V63.7188H47.4531V66.5312ZM47.4531 58.5625H62.5469V55.75H47.4531V58.5625ZM42.8125 74.5C42.0625 74.5 41.4062 74.2188 40.8437 73.6562C40.2812 73.0938 40 72.4375 40 71.6875V39.8125C40 39.0625 40.2812 38.4063 40.8437 37.8438C41.4062 37.2813 42.0625 37 42.8125 37H59.7344L70 47.2656V71.6875C70 72.4375 69.7187 73.0938 69.1562 73.6562C68.5937 74.2188 67.9375 74.5 67.1875 74.5H42.8125ZM58.3281 48.5312V39.8125H42.8125V71.6875H67.1875V48.5312H58.3281ZM42.8125 39.8125V48.5312V39.8125V71.6875V39.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8312 12.6017C53.8312 11.6847 53.0875 10.9381 52.1713 10.9733C44.0839 11.2838 36.2271 13.8583 29.4799 18.4268C22.2719 23.3072 16.6539 30.244 13.3364 38.3599C10.019 46.4758 9.15097 55.4063 10.8422 64.022C12.4254 72.0872 16.1845 79.5375 21.6867 85.5521C22.3073 86.2304 23.3659 86.2284 24.0117 85.574C24.6455 84.9318 24.6428 83.9016 24.0351 83.2346C18.9741 77.6802 15.5156 70.8097 14.0561 63.3742C12.4913 55.4026 13.2944 47.1397 16.3639 39.6306C19.4333 32.1215 24.6313 25.7033 31.3004 21.1877C37.5087 16.9842 44.7322 14.6051 52.1713 14.2964C53.0874 14.2583 53.8312 13.5186 53.8312 12.6017Z",
    fill: "url(#paint2_linear_11411_57199)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11411_57199",
    x: 0,
    y: 0.941406,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0823529 0 0 0 0 0.196078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11411_57199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11411_57199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11411_57199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55.9414) rotate(89.2559) scale(45.0038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762092,
    stopColor: "#0D116B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11411_57199",
    x1: 28.7013,
    y1: 20.8765,
    x2: 52.6623,
    y2: 55.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E61D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E62D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11411_57199",
    x1: 53.8312,
    y1: 10.9414,
    x2: 25.7877,
    y2: 87.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.569ab3d71c08e9f6194516f17ccf2d0f.svg";
export { ForwardRef as ReactComponent };